import React from 'react';
import './popup.css';

interface UserResponsePopupProps {
    isOpen: boolean;
    isSuccess: boolean;
    message: string;
    onClose: () => void;
}

const UserResponsePopup: React.FC<UserResponsePopupProps> = ({ isOpen, isSuccess, message, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div className={`popup-content ${isSuccess ? 'success' : 'error'}`}>
                <div className="popup-header">
                    <span className={`popup-icon ${isSuccess ? 'success' : 'error'}`}>
                        {isSuccess ? '✓' : '!'}
                    </span>
                    <h3>{isSuccess ? 'פעולה בוצעה בהצלחה' : 'פעולה נכשלה'}</h3>
                </div>
                <div className="popup-body">
                    <p>{message}</p>
                </div>
                <div className="popup-close-button-container">
                    <button className="popup-close" onClick={onClose}>
                        סגירה
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserResponsePopup;